import $ from 'jquery';

$(document).ready(function () {

  $('.js-slick-slider').each(function () {
    var $thisSlider = $(this);
    var $section = $thisSlider.closest('.large-image');

    $thisSlider.slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: false,
      prevArrow: $section.find('.custom-prev-btn'),
      nextArrow: $section.find('.custom-next-btn')
    });
  });
});

function acfExampleBlock() {
  $('.js-acf-example-block').each(function () {
  });
}
